<template>
  <div class="logindiv">
    <div class="logo">
      <img alt="logo" src="@/assets/logo-biomedica-laboratorija.png"  height="60">
    </div>
    <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="logimtitle">
        <h2>PRIJAVA U eLAB</h2>
      </div>
      <div class="usernamediv">
        <div class="userpasspanel p-input-icon-right">
            <i class="pi pi-envelope" />
            <label for="email">{{ translated('username') }}*</label>
            <input id="email" v-model="v$.username.$model" aria-describedby="email-error" ref="usernameInput" @keyup.enter="onEnterInUsername"/>            
        </div>
                     
      </div>

      <div class="passdiv">

        <div class="userpasspanel p-input-icon-right">            
            <!-- <Password id="password" ref="passwordInput" v-model="v$.password.$model" toggleMask :feedback=false @keypress="changedInput" @keyup.enter="handleSubmit(!v$.$invalid)" aria-describedby="email-error"/> -->
            <label for="password">{{ translated('password') }}*</label>
            <input id="password" type="password" ref="passwordInput" v-model="v$.password.$model" toggleMask :feedback=false @keypress="changedInput" @keyup.enter="handleSubmit(!v$.$invalid)" aria-describedby="email-error"/>            
        </div>

      </div>

      <div class="langdiv">
        <div class="langpanel p-float-label p-input-icon-right">            
            <Dropdown v-model="selectedLanguage" :options="languages" optionLabel="name" placeholder="" class="langdropdown w-full md:w-14rem" />
            <label for="language-select">{{ translated('UILang') }}</label>
        </div>

      </div>      

      <div class="errordiv">
        <small v-if="error && isChanged==false">{{ error }}</small>         
      </div>
      

      <div class="submitbutton">
        <Button :label="translated('login')" @click="handleSubmit(!v$.$invalid)" />
				<div class="p-col-12 donthaveaccount">
				  <a @click="createAccount">{{ translated('donthaveaccount') }}</a>
				</div>	        
				<div class="p-col-12 donthaveaccount">
				  <a @click="forgotPassword">{{ translated('forgotPassword') }}</a>
				</div>	          
      </div>


    </form>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "@/store";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import router from "@/router";
import Dropdown from 'primevue/dropdown';

export default {
    setup: () => ({ v$: useVuelidate() }),  
    data() {
        return {
            username: '',
            password: '',
            submitted: false,
            isChanged: false,
            error: computed(() => store.state.error),
            translated: computed(() => store.getters.getTranslate),  
            selectedLanguage: null,
            languages: 
            [
              { name: 'Srpski', code: 'SR' },
              { name: 'English', code: 'EN' }
            ]
        }
    },
    watch: {
      selectedLanguage() {
        debugger;

        let selectedCodelang = undefined;
        if(this.selectedLanguage != undefined) {
          selectedCodelang = this.selectedLanguage.code;
        }

        if(store.getters.getUserlanguage != selectedCodelang) {
          let model = { Language: selectedCodelang };
          store.dispatch("setNewLanguage", model);
          this.$forceUpdate();     
        }
      },
    },  
    validations() {
        return {
            username: {
                required,
                email
            },
            password: {
                required
            }
        }
    },      
    created() { 
      debugger;
      // console.log('LOGIN !!!');
      let currentLang = store.getters.getUserlanguage;

      if(currentLang != ''){
        this.selectedLanguage = this.languages.find(x => x.code == currentLang);
      }
      
    },       
    methods: {
        createAccount() {
            router.push("register");
        }, 
        forgotPassword () {
            router.push("forgotpassword");
        },     
        async handleSubmit(isFormValid) {
          this.isChanged = false
            //// console.log('klicem submit:' + isFormValid)
            this.submitted = true;

            if (!isFormValid) {
                return;
            }

            let selectedCodelang = "EN";
            if(this.selectedLanguage != undefined) {
              selectedCodelang = this.selectedLanguage.code;
            }

            let model = {
                Username: this.username,
                Password: this.password,
                Language: selectedCodelang
            }

            //// console.log(model)
            store.dispatch("login", model);
        },
        async changedInput() {
          this.isChanged = true
        },
        simulateTabKey(element) {
          // Create a new KeyboardEvent
          let event = new KeyboardEvent('keydown', {
              'key': 'Tab',
              'code': 'Tab',
              'view': window,
              'altKey': false,
              'ctrlKey': false,
              'shiftKey': false,
              'metaKey': false,
              'bubbles': true,
              'cancelable': true
          });

          // Dispatch the event on the given element
          element.dispatchEvent(event);
        },
        onEnterInUsername() {
          debugger;
          this.$refs.passwordInput.focus();
          // this.simulateTabKey(this.$refs.usernameInput);
        }
    }
}



</script>

<style scoped>
  .donthaveaccount {
      text-align: center;
      cursor: pointer;
  }

  form {
    background: white;
    padding: 20px;
    border-radius: 0 0 10px 10px;
  }

  form button {
    display: block;
    margin: 10px auto 0;
  }

  .logo img {display: block;margin-left: auto;margin-right: auto;}

  .logindiv .logo {
    background: #f2f2f2;
    padding:10px;
    padding-bottom: 40px;;
  }

.userpasspanel {
    width: 100%;
} 

.usernamediv {
    margin-top: 30px;
}

.donthaveaccount {
    margin-top: 20px;
}

.langdiv {
    margin-top: 50px;
}

.langpanel {
    width: 100%;
}

.langpanel .langdropdown {width: 100% !important;}

i.pi.pi-envelope { margin-top:5px;margin-right: 5px;}

#email, #password { border: 1px solid lightgray;}

h2 {text-align: center;}
.donthaveaccount {font-size: 1.3em;}
button.p-button.p-component {font-size: 1.7em;}

</style>
